import moment from "moment";
import { patient, dashboard } from "../helpers/api/api";
import { useState, useEffect, useRef } from "react";
import { role } from "../helpers/Constants";
import { Link } from "react-router-dom";
import { Tabs, Tab, Spinner, Form, Button } from "react-bootstrap";
import { Patients } from "../Dashboard/Tabs/Patients";
import { Therapies } from "../Dashboard/Tabs/Therapies";
import { Monitoring } from "../Dashboard/Tabs/Monitoring";
import { ContactInfo } from "../Dashboard/Tabs/ContactInfo";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function DoctorChartsInterface() {
  const user = JSON.parse(localStorage.getItem("role"));
  const isCareManger = user.idRole === role.CAREMANAGER ? true : false;
  const isAngelini = user.idRole === role.ADMIN ? true : false;
  const isDoctor = user.idRole === role.DOCTOR ? true : false;
  const date = new Date();
  const [loading, setLoading] = useState(false);
  const [key, setKey] = useState("patients");
  const [dataInizio, setDataInizio] = useState(moment(date).toDate());
  const [dataFine, setDataFine] = useState(moment(date).toDate());
  const [creationDatesPatients, setCreationDatesPatients] = useState([]);
  const [minDate, setMinDate] = useState();
  //Assistiti
  const [dataGetTotalRegisterActive, setDataGetTotalRegisterActive] =
    useState("");
  const [dataGetTotalNumberDropOff, setDataGetTotalNumberDropOff] =
    useState("");
  const [dataGetAllDropOff, setDataGetAllDropOff] = useState([]);
  const [dataGetBySex, setDataGetBySex] = useState([]);
  const [dataGetMonthlyTrend, setDataGetMonthlyTrend] = useState([]);
  const [dataGetByAge, setDataGetByAge] = useState([]);
  const [dataGetCountAssisititiMedici, setDataGetCountAssisititiMedici] =
    useState([]);
  //Terapia
  const [dataGetAllPatientByFormulation, setDataGetAllPatientByFormulation] =
    useState([]);
  const [dataGetDayByFormulation, setDataGetDayByFormulation] = useState([]);
  const [dataGetPatientsByPhase, setDataGetPatientsByPhase] = useState([]);
  //Monitoraggio
  const [
    dataGetPatientsByEpilecticSeizure,
    setDataGetPatientsByEpilecticSeizure,
  ] = useState([]);
  const [dataGetAdherencesByPatient, setDataGetAdherencesByPatient] = useState(
    []
  );
  const [dataGetTherapyAdherence, setDataGetTherapyAdherence] = useState([]);
  const [dataGetTrackingMoodByPatient, setDataGetTrackingMoodByPatient] =
    useState([]);
  // const [dataGetAdverseEventsByEvent, setDataGetAdverseEventsByEvent] =
  //   useState([]);
  const [dataGetGroupEventiAvversi, setDataGetGroupEventiAvversi] = useState(
    []
  );
  const [dataGetCumulativeSurveysByMood, setDataGetCumulativeSurveysByMood] =
    useState([]);
  //ContactInfo
  //const [dataGetAllContactInfoByPatient, setDataGetAllContactInfoByPatient] = useState([]);
  const [
    dataGetNumeroMedioContattiPaziente,
    setDataGetNumeroMedioContattiPaziente,
  ] = useState([]);
  const [dataGetAllContactInfoByNumber, setDataGetAllContactInfoByNumber] =
    useState([]);
  const [
    dataGetSatisfactionLevelQuestionOne,
    setDataGetSatisfactionLevelQuestionOne,
  ] = useState([]);
  const [
    dataGetSatisfactionLevelQuestionTwo,
    setDataGetSatisfactionLevelQuestionTwo,
  ] = useState([]);
  const [
    dataGetSatisfactionLevelQuestionThree,
    setDataGetSatisfactionLevelQuestionThree,
  ] = useState([]);
  const [dataGetTempoMedioContatto, setDataGetTempoMedioContatto] = useState(
    []
  );

  useEffect(() => {
    if (loading) {
      document.body.style.overflow = "hidden";
      document.body.style.height = "100%";
    }
    if (!loading) {
      document.body.style.overflow = "auto";
      document.body.style.height = "auto";
    }
  }, [loading]);

  useEffect(() => {
    let request = null;
    if (
      JSON.parse(localStorage.getItem("role")).idRole === role.CAREMANAGER ||
      JSON.parse(localStorage.getItem("role")).idRole === role.ADMIN
    ) {
      request = patient.getAll("GetAll");
    } else {
      request = patient.get(
        "GetByDoctor/",
        JSON.parse(localStorage.getItem("role")).id
      );
    }
    request
      .then((response) => {
        if (response.status !== 200) {
          return;
          //setCreationDatesPatients(moment(date).format("YYYY-MM-DD"));
        }
        const arr = response.data.dati
          ?.map(function (item) {
            return moment.min(item["creationDate"]);
          })
          .filter((item) => item);
        if (arr.length === 0) {
          arr.push(moment(date).format("YYYY-MM-DD"));
          setCreationDatesPatients(arr);
        } else {
          setCreationDatesPatients(arr);
        }

        setLoading(false);
      })
      .catch((error) => {});
  }, []);

  useEffect(() => {
    if (!creationDatesPatients?.length) {
      return;
    }
    const sorted = creationDatesPatients.sort((a, b) => {
      const newA = a.split("/").reverse().join("-");
      const newB = b.split("/").reverse().join("-");
      return +new Date(newA) - +new Date(newB);
    });
    setMinDate(sorted[0]);
    const dateMomentObject = moment(sorted[0], "DD-MM-YYYY");
    const dateObject = dateMomentObject.toDate();
    setDataInizio(moment(dateObject).toDate());
  }, [creationDatesPatients]);

  console.log(minDate);
  useEffect(() => {
    if (!minDate) {
      return;
    }
    callsFetchData();
  }, [minDate]);

  function fetchData(evt) {
    evt.preventDefault();
    callsFetchData();
  }

  // function fillMinDate() {
  //   const sorted = creationDatesPatients.sort((a, b) => {
  //     const newA = a.split("/").reverse().join("-");
  //     const newB = b.split("/").reverse().join("-");
  //     return +new Date(newA) - +new Date(newB);
  //   });
  //   console.log(sorted);
  //   setMinDate(sorted[0]);
  //   const dateMomentObject = moment(sorted[0], "DD-MM-YYYY");
  //   const dateObject = dateMomentObject.toDate();
  //   setDataInizio(moment(dateObject).format("YYYY-MM-DD"));
  // }

  function callsFetchData() {
    //Assstiti
    dashboard
      .getWithParam("GetTotalRegister&Active/", {
        params: { DataFine: dataFine, DataInizio: dataInizio },
      })
      .then((response) => {
        if (response.status === 200) {
          setDataGetTotalRegisterActive(response.data.dati);
        }
      })
      .catch((error) => {});
    dashboard
      .getWithParam("GetTotalNumberDropOff/", {
        params: { DataFine: dataFine, DataInizio: dataInizio },
      })
      .then((response) => {
        if (response.status === 200) {
          setDataGetTotalNumberDropOff(response.data.dati);
        }
      })
      .catch((error) => {});
    dashboard
      .getWithParam("GetAllDropOff/", {
        params: { DataFine: dataFine, DataInizio: dataInizio },
      })
      .then((response) => {
        if (response.status === 200) {
          setDataGetAllDropOff(response.data.dati);
        }
      })
      .catch((error) => {});
    dashboard
      .getWithParam("GetByAge/", {
        params: { DataFine: dataFine, DataInizio: dataInizio },
      })
      .then((response) => {
        if (response.status === 200) {
          var res = response.data.dati.map(function (x) {
            x.attivazioni = parseInt(x.attivazioni);
            x.registrazioni = parseInt(x.registrazioni);
            return x;
          });
          setDataGetByAge(res);
        }
      })
      .catch((error) => {});
    dashboard
      .getWithParam("GetBySex/", {
        params: { DataFine: dataFine, DataInizio: dataInizio },
      })
      .then((response) => {
        if (response.status === 200) {
          var res = response.data.dati.map(function (x) {
            x.attivazioni = parseInt(x.attivazioni);
            x.registrazioni = parseInt(x.registrazioni);
            return x;
          });
          setDataGetBySex(res);
        }
      })
      .catch((error) => {});
    dashboard
      .getWithParam("GetMonthlyTrend/", {
        params: { DataFine: dataFine, DataInizio: dataInizio },
      })
      .then((response) => {
        if (response.status === 200) {
          setDataGetMonthlyTrend(response.data.dati);
        }
      })
      .catch((error) => {});
    //GetCountAssisititiMedici
    dashboard
      .getWithParam("GetCountAssisititiMedici/", {
        params: { DataFine: dataFine, DataInizio: dataInizio },
      })
      .then((response) => {
        if (response.status === 200) {
          setDataGetCountAssisititiMedici(response.data.dati);
        }
      })
      .catch((error) => {});
    //Terapia
    dashboard
      .getWithParam("GetAllPatientsByFormulation/", {
        params: { DataFine: dataFine, DataInizio: dataInizio },
      })
      .then((response) => {
        if (response.status === 200) {
          var res = response.data.dati.map(function (x) {
            x.formula = parseInt(x.formula);
            return x;
          });
          setDataGetAllPatientByFormulation(res);
        }
      })
      .catch((error) => {});
    dashboard
      .getWithParam("GetDayByFormulation/", {
        params: { DataFine: dataFine, DataInizio: dataInizio },
      })
      .then((response) => {
        if (response.status === 200) {
          setDataGetDayByFormulation(response.data.dati);
        }
      })
      .catch((error) => {});
    dashboard
      .getWithParam("GetPatientsByPhase/", {
        params: { DataFine: dataFine, DataInizio: dataInizio },
      })
      .then((response) => {
        if (response.status === 200) {
          setDataGetPatientsByPhase(response.data.dati);
        }
      })
      .catch((error) => {});
    //Monitoraggio
    if (isDoctor || isCareManger) {
      dashboard
        .getWithParam("GetPatientsByEpilecticSeizure/", {
          params: { DataFine: dataFine, DataInizio: dataInizio },
        })
        .then((response) => {
          if (response.status === 200) {
            setDataGetPatientsByEpilecticSeizure(response.data.dati);
          }
        })
        .catch((error) => {
          setDataGetPatientsByEpilecticSeizure([]);
        });
      dashboard
        .getWithParam("GetAdherencesByPatient/", {
          params: { DataFine: dataFine, DataInizio: dataInizio },
        })
        .then((response) => {
          if (response.status === 200) {
            setDataGetAdherencesByPatient(response.data.dati);
          }
        })
        .catch((error) => {
          setDataGetAdherencesByPatient([]);
        });
    }
    if (isAngelini || isCareManger) {
      dashboard
        .getWithParam("GetTherapyAdherence/", {
          params: { DataFine: dataFine, DataInizio: dataInizio },
        })
        .then((response) => {
          if (response.status === 200) {
            setDataGetTherapyAdherence(response.data.dati);
          }
        })
        .catch((error) => {
          setDataGetTherapyAdherence([]);
        });
    }
    dashboard
      .getWithParam("GetTrackingMoodByPatient/", {
        params: { DataFine: dataFine, DataInizio: dataInizio },
      })
      .then((response) => {
        if (response.status === 200) {
          setDataGetTrackingMoodByPatient(response.data.dati);
        }
      })
      .catch((error) => {
        setDataGetTrackingMoodByPatient([]);
      });
    // dashboard
    //   .getWithParam("GetAdverseEventsByEvent/", {
    //     params: { DataFine: dataFine, DataInizio: dataInizio },
    //   })
    //   .then((response) => {
    //     if (response.status === 200) {
    //       setDataGetAdverseEventsByEvent(response.data.dati);
    //     }
    //   })
    //   .catch((error) => {
    //     setDataGetAdverseEventsByEvent([]);
    //   });

    //Refactoring eventi avversi
    dashboard
      .getWithParam("GetGroupEventiAvversi/", {
        params: { DataFine: dataFine, DataInizio: dataInizio },
      })
      .then((response) => {
        //onsole.log("GetGroupEventiAvversi : " + JSON.stringify(response.data));
        if (response.status === 200) {
          const arrDati = response.data.dati;
          setDataGetGroupEventiAvversi(arrDati);
        }
      })
      .catch((error) => {
        setDataGetGroupEventiAvversi([]);
      });
    if (isAngelini) {
      dashboard
        .getWithParam("GetCumulativeSurveysByMood/", {
          params: { DataFine: dataFine, DataInizio: dataInizio },
        })
        .then((response) => {
          if (response.status === 200) {
            setDataGetCumulativeSurveysByMood(response.data.dati);
          }
        })
        .catch((error) => {});
    }
    //ContactInfo
    if (isAngelini || isCareManger) {
      // dashboard.getWithParam("GetAllContactInfoByPatient/", { params: { DataFine: dataFine, DataInizio: dataInizio } })
      //     .then((response) => {
      //         if (response.status === 200) {
      //             setDataGetAllContactInfoByPatient(response.data.dati);
      //         }
      //     }).catch((error) => {

      //     });
      dashboard
        .getWithParam("GetNumeroMedioContattiPaziente/", {
          params: { DataFine: dataFine, DataInizio: dataInizio },
        })
        .then((response) => {
          if (response.status === 200) {
            setDataGetNumeroMedioContattiPaziente(response.data.dati);
          }
        })
        .catch((error) => {});
      dashboard
        .getWithParam("GetAllContactInfoByNumber", {
          params: { DataFine: dataFine, DataInizio: dataInizio },
        })
        .then((response) => {
          if (response.status === 200) {
            setDataGetAllContactInfoByNumber(response.data.dati);
          }
        })
        .catch((error) => {});
      dashboard
        .getWithParam("GetValutazioniServizio", {
          params: { DataFine: dataFine, DataInizio: dataInizio },
        })
        .then((response) => {
          if (response.status === 200) {
            setDataGetSatisfactionLevelQuestionOne(response.data.dati);
          }
        })
        .catch((error) => {});
      dashboard
        .getWithParam("GetServiceSuggestions", {
          params: { DataFine: dataFine, DataInizio: dataInizio },
        })
        .then((response) => {
          if (response.status === 200) {
            setDataGetSatisfactionLevelQuestionTwo(response.data.dati);
          }
        })
        .catch((error) => {});
      dashboard
        .getWithParam("GetAdditionalServiceFeatures", {
          params: { DataFine: dataFine, DataInizio: dataInizio },
        })
        .then((response) => {
          if (response.status === 200) {
            setDataGetSatisfactionLevelQuestionThree(response.data.dati);
          }
        })
        .catch((error) => {});
      dashboard
        .getWithParam("GetTempoMedioContatto", {
          params: { DataFine: dataFine, DataInizio: dataInizio },
        })
        .then((response) => {
          if (response.status === 200) {
            setDataGetTempoMedioContatto(response.data.dati);
          }
        })
        .catch((error) => {});
    }
  }

  const commonProperties = {
    width: 400,
    height: 330,
    animate: false,
    activeOuterRadiusOffset: 8,
  };

  const componentRef = useRef();

  function resolveDownloadPDF() {
    return new Promise(() => {
      
      setTimeout(() => {
        const input = componentRef.current;
        html2canvas(input).then((canvas) => {
          const imgWidth = 208;
          const pageHeight = 295;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;
          let heightLeft = imgHeight;
          let position = 0;
          heightLeft -= pageHeight;
          const doc = new jsPDF("p", "mm", "a4", true);
          doc.addImage(
            canvas,
            "PNG",
            0,
            position,
            imgWidth,
            imgHeight,
            "",
            "MEDIUM"
          );
          while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            doc.addPage();
            doc.addImage(
              canvas,
              "PNG",
              0,
              position,
              imgWidth,
              imgHeight,
              "",
              "MEDIUM"
            );
            heightLeft -= pageHeight;
          }
          doc.save("EpiOnApp_download.pdf");
          setLoading(false);
          window.location.reload();
        });
      }, 500);
    });
  }

  const handleDownloadPDF = async () => {
    setLoading(true);
    document.getElementsByClassName("nav secondary-menu mb-4 nav nav-tabs")[0].style.display = "none";

    var patients = document.getElementById("charts-tabs-tabpane-patients");
    var therapies = document.getElementById("charts-tabs-tabpane-therapies");
    var tabpaneMonitoring = document.getElementById("charts-tabs-tabpane-monitoring");
    var elencoMediciChart = document.getElementById("elencoMediciChart");
    var tableSatisfaction = document.getElementById("table-satisfaction");
    var contactInfo = document.getElementById("charts-tabs-tabpane-contactInfo");
    if (patients)
    {
      patients.className = "fade tab-pane active show";
    }

    if (therapies)
    {
      therapies.className = "fade tab-pane active show";
      if (elencoMediciChart)
      {
        therapies.style.paddingTop = "750px";

      }
      else
      {
        therapies.style.paddingTop = "30px";

      }
    }
    

    if (tabpaneMonitoring){
      tabpaneMonitoring.className = "fade tab-pane active show";
      tabpaneMonitoring.style.paddingTop = "380px";
    }

    if (elencoMediciChart)
    {
      elencoMediciChart.style.paddingTop = "200px";
    }
    
    if (tableSatisfaction)
    {
      tableSatisfaction.style.paddingTop = "70px";
    }
    
    if (contactInfo)
    {
      contactInfo.className = "fade tab-pane active show";
    }
    

    await resolveDownloadPDF();
  };

  return (
    <>
      <div className="row mb-4">
        <form onSubmit={fetchData}>
          <div className="row align-items-center g-0 g-md-3">
            {dataInizio && (
              <div className="col-12 col-md-3">
                <div className="input-group mb-3" style={{ width: "92%" }}>
                  <div className="row">
                    <div className="col-2">
                      <span className="input-group-text" id="label-inizio">
                        Dal
                      </span>
                    </div>
                    <div className="col-10">
                      <DatePicker
                        selectsStart
                        selected={dataInizio}
                        onChange={(dataInizio) => setDataInizio(dataInizio)}
                        startDate={dataInizio}
                        className="form-control form-control-sm"
                        id="dataI"
                        aria-describedby="label-data"
                        name="dataInizio"
                        maxDate={moment(date).toDate()}
                        locale="it"
                        dateFormat="dd/MM/yyyy"
                        showMonthDropdown
                        showYearDropdown
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="col-12 col-md-3">
              <div className="input-group mb-3" style={{ width: "92%" }}>
                <div className="row">
                  <div className="col-2">
                    <span className="input-group-text" id="label-inizio">
                      al
                    </span>
                  </div>
                  <div className="col-10">
                    <DatePicker
                      selectsEnd
                      selected={dataFine}
                      onChange={(dataFine) => setDataFine(dataFine)}
                      endDate={dataFine}
                      startDate={dataFine}
                      maxDate={moment(date).toDate()}
                      className="form-control form-control-sm"
                      id="dataF"
                      aria-describedby="label-data"
                      locale="it"
                      dateFormat="dd/MM/yyyy"
                      showMonthDropdown
                      showYearDropdown
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3">
              <button
                className="btn btn-primary btn-upload form-control form-control-sm"
                type="submit"
              >
                Seleziona
              </button>
            </div>
            <div className="col-12 col-md-3">
              {loading ? (
                <div className="row d-flex justify-content-center">
                  <Spinner
                    animation="border"
                    role="status"
                    style={{ color: "DarkViolet" }}
                  >
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                  <div className="d-flex justify-content-center">
                    <span>Downloading...</span>
                  </div>
                </div>
              ) : (
                <button
                  className="btn btn-primary btn-download form-control form-control-sm"
                  onClick={handleDownloadPDF}
                >
                  Scarica pdf 
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
      <div ref={componentRef}>
        <Tabs
          id="charts-tabs"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="nav secondary-menu mb-4"
          style={{ paddingLeft: 50 }}
        >
          <Tab eventKey="patients" title="Assistiti">
            <Patients
              dataGetTotalRegisterActive={dataGetTotalRegisterActive}
              dataGetTotalNumberDropOff={dataGetTotalNumberDropOff}
              dataGetAllDropOff={dataGetAllDropOff}
              dataGetByAge={dataGetByAge}
              dataGetMonthlyTrend={dataGetMonthlyTrend}
              dataGetBySex={dataGetBySex}
              dataGetCountAssisititiMedici={dataGetCountAssisititiMedici}
              commonProperties={commonProperties}
            />
          </Tab>
          <Tab eventKey="therapies" title="Terapia Ontozry">
            <Therapies
              dataGetAllPatientByFormulation={dataGetAllPatientByFormulation}
              dataGetDayByFormulation={dataGetDayByFormulation}
              dataGetPatientsByPhase={dataGetPatientsByPhase}
              commonProperties={commonProperties}
            />
          </Tab>
          <Tab eventKey="monitoring" title="Monitoraggio">
            <Monitoring
              dataGetPatientsByEpilecticSeizure={
                dataGetPatientsByEpilecticSeizure
              }
              dataGetAdherencesByPatient={dataGetAdherencesByPatient}
              dataGetTherapyAdherence={dataGetTherapyAdherence}
              dataGetTrackingMoodByPatient={dataGetTrackingMoodByPatient}
              //dataGetAdverseEventsByEvent={dataGetAdverseEventsByEvent}
              dataGetGroupEventiAvversi={dataGetGroupEventiAvversi}
              dataGetCumulativeSurveysByMood={dataGetCumulativeSurveysByMood}
              commonProperties={commonProperties}
            />
          </Tab>
          {isCareManger || isAngelini ? (
            <Tab eventKey="contactInfo" title="Contact info">
              <ContactInfo
                dataGetNumeroMedioContattiPaziente={
                  dataGetNumeroMedioContattiPaziente
                }
                //dataGetAllContactInfoByPatient={dataGetAllContactInfoByPatient}
                dataGetAllContactInfoByNumber={dataGetAllContactInfoByNumber}
                dataGetSatisfactionLevelQuestionOne={
                  dataGetSatisfactionLevelQuestionOne
                }
                dataGetSatisfactionLevelQuestionTwo={
                  dataGetSatisfactionLevelQuestionTwo
                }
                dataGetSatisfactionLevelQuestionThree={
                  dataGetSatisfactionLevelQuestionThree
                }
                dataGetTempoMedioContatto={dataGetTempoMedioContatto}
                commonProperties={commonProperties}
              />
            </Tab>
          ) : (
            ""
          )}
        </Tabs>
      </div>
      &nbsp;&nbsp;&nbsp;
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 mb-3 d-flex justify-content-center justify-content-md-start">
            {JSON.parse(localStorage.getItem("role")).idRole ==
              role.CAREMANAGER ||
            JSON.parse(localStorage.getItem("role")).idRole == role.DOCTOR ? (
              <Link to={`/Dashboard`}>
                <button className="btn btn-primary me-3" id="">
                  Elenco assistiti
                </button>{" "}
              </Link>
            ) : (
              ""
            )}
          </div>
        </div>
        {/* <div className="row">
          <div className="col-12 mb-3 d-flex justify-content-center justify-content-md-start">
            {JSON.parse(localStorage.getItem("role")).idRole ==
              role.CAREMANAGER ||
            JSON.parse(localStorage.getItem("role")).idRole == role.DOCTOR ? (
              <button
                className="btn btn-primary me-3"
                onClick={handleDownloadPDF}
                id
              >
                Scarica pdf
              </button>
            ) : (
              ""
            )}
          </div>
        </div> */}
      </div>
    </>
  );
}

export { DoctorChartsInterface };
